var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bee-label',{attrs:{"empty-state":_vm.emptyState,"bold":_vm.bold,"color":_vm.color,"content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }